import { IconX } from '@tabler/icons-react';
import { useSetAtom } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

import PopoverMenuButtonItem from '@/components/PopoverMenuButton/PopoverMenuButtonItem';

import { resetProgressModalOpenAtomFamily } from '../../../state';

interface ResetProgressManageMenuItemProps {
  /**
   * The team member has at least one step in progress
   * and is not complete.
   * @default false
   */
  isInProgress?: boolean;
  teamMemberId: string;
}

/**
 * This is the red "Reset Progress" menu item in
 * the three dot menu for manage plans > plan > team member card.
 */
const ResetProgressManageMenuItem: React.FC<
  ResetProgressManageMenuItemProps
> = ({ isInProgress = false, teamMemberId }) => {
  const { t } = useTranslation();
  const { reassignPlansEpic: reassignPlansEpicFF } = useFlags();
  const setResetModalOpen = useSetAtom(
    resetProgressModalOpenAtomFamily(teamMemberId),
  );

  if (!isInProgress || !reassignPlansEpicFF) {
    return null;
  }

  return (
    <>
      <PopoverMenuButtonItem
        data-testid="ResetProgress"
        icon={<IconX />}
        onClick={() => setResetModalOpen(true)}
        text={t('Button.resetProgress')}
        className="text-feedback-error-base!"
      />
    </>
  );
};

export default ResetProgressManageMenuItem;
